import { createSelector } from 'reselect';

export const getAccountLastFour = createSelector(
  state =>
    state?.orderPlaced?.fundsVerification?.achSubscription.accountLastFour,
  accountLastFour => accountLastFour
);

export const getAvailableOptions = createSelector(
  state => state.dashboard.availableOptions,
  availableOptions => availableOptions
);

export const getCanRollback = createSelector(
  state => state.dashboard.canRollback,
  canRollback => canRollback
);

export const getCoBuyer = createSelector(
  state => state.dashboard.availableOptions.coBuyer,
  coBuyer => {
    return {
      ...coBuyer,
      hasCoBuyer: coBuyer?.email?.length > 0
    };
  }
);

export const getFundsVerification = createSelector(
  state => state?.orderPlaced?.fundsVerification?.verifications,
  verifications => verifications
);

export const getIsCashAdvance = createSelector(
  state => state?.dashboard?.isCashAdvance,
  isCashAdvance => isCashAdvance
);

export const getNotarizeStatus = createSelector(
  state => state.orderPlaced.notarize,
  notarize => notarize
);

export const getOrderId = createSelector(
  state => state.dashboard.status.orderId,
  orderId => orderId
);

export const getOrderPlacedHasLoaded = createSelector(
  state => state.orderPlaced?.root?.hasLoaded,
  hasLoaded => hasLoaded
);

export const getSchedulerIsLoaded = createSelector(
  state => state.orderPlaced.rescheduleModal.schedulerIsLoaded,
  schedulerIsLoaded => schedulerIsLoaded
);

export const getScreenSize = createSelector(
  state => state.ui?.screenSize,
  screenSize => screenSize
);

export const getOrderSummary = createSelector(
  state => state?.dashboard?.orderSummary,
  orderSummary => orderSummary
);

export const getContractsSigned = createSelector(
  state => state?.orderPlaced?.contracts?.contractsSigned,
  contractsSigned => contractsSigned
);

export const getCustomerIsGreen = createSelector(
  state =>
    state?.orderPlaced?.fundsVerification?.verifications?.customerIsGreen,
  customerIsGreen => customerIsGreen
);

export const getContracts2crPhase2 = createSelector(
  state => state.orderPlaced?.root?.isContractToCRPhase2,
  isContractToCRPhase2 => isContractToCRPhase2
);

export const getShowOrderSummary = createSelector(
  state => state.orderPlaced?.root.showOrderSummary,
  showOrderSummary => showOrderSummary
);

export const getToastMessage = createSelector(
  state => state.orderPlaced.root?.toastMessage,
  toastMessage => toastMessage
);

export const getVehicle = createSelector(
  state => state.vehicle,
  vehicle => vehicle
);

export const getIsNRSF = createSelector(
  state => state.orderPlaced?.root?.isNRSF,
  isNRSF => isNRSF
);

export const getIsContractToCR = createSelector(
  state => state.orderPlaced?.root?.isContractToCR,
  isContractToCR => isContractToCR
);

export const getPaymentSummary = createSelector(
  state => state.orderPlaced?.root?.paymentSummary,
  paymentSummary => paymentSummary
);
